import type { MaybeRefOrGetter } from 'vue';
import type { UploadFileOptions } from '#layers/assets/stores/upload';
import type { MonospaceFile } from '#layers/data-model/public';
import { tryOnScopeDispose } from '@vueuse/core';
import { readonly, ref, toValue } from 'vue';
import { useUploadStore } from '#layers/assets/stores/upload';

export function useFileUpload(options: MaybeRefOrGetter<UploadFileOptions> = {}) {
	const uploadStore = useUploadStore();

	const isUploading = ref(false);

	// Ignore upload results after the owning scope is disposed.
	let isAlive = true;

	tryOnScopeDispose(() => {
		isAlive = false;
	});

	async function uploadFiles(files: File[]): Promise<MonospaceFile[]> {
		if (files.length === 0) return [];

		isUploading.value = true;

		try {
			const uploaded = await uploadStore.uploadFiles(files, toValue(options));
			if (!isAlive) return [];
			return uploaded;
		}
		finally {
			if (isAlive) isUploading.value = false;
		}
	}

	return {
		uploadFiles,
		isUploading: readonly(isUploading),
	};
}
